import React, { useState, useEffect } from 'react';
import postal from 'postal';
import Modal from 'react-modal';
import Spinner from './ui/Spinner';

const ModalContentStyle:React.CSSProperties = {
  top: '50%',
  left: '50%',
  right: 'auto',
  bottom: 'auto',
  marginRight: '-50%',
  transform: 'translate(-50%, -50%)',
  zIndex: 10000
};

const ModalOverlayStyle:React.CSSProperties = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.55)',
  zIndex: 999998
};

// export const GlobalApiLoadingBar = () => {
//   const [apiLoading, setApiLoading] = useState(false);

//   useEffect(() => {
//     const start = postal.subscribe({ channel: 'ajax', topic: 'ajax.start', callback: () => setApiLoading(true) });
//     const end = postal.subscribe({ channel: 'ajax', topic: 'ajax.end', callback: () => setApiLoading(false) });
//     return () => { start.unsubscribe(); end.unsubscribe(); };
//   }, []);

//   if (!apiLoading) return null;

//   return (
//     <div style={{ position: 'fixed', top: '-4px', width: '100%', zIndex: 5000 }}>
//       <SkeletonTheme color="#4287f5" highlightColor="#b9d2fa">
//         <Skeleton count={1} height={2} />
//       </SkeletonTheme>
//     </div>
//   );
// };

export const GlobalLoadingModal = () => {
  const [apiLoadingMessage, setApiLoadingMessage] = useState(false);

  useEffect(() => {
    const start = postal.subscribe({ channel: 'ajax', topic: 'ajax.loadingstart', callback: () => setApiLoadingMessage(true) });
    const end = postal.subscribe({ channel: 'ajax', topic: 'ajax.loadingend', callback: () => setApiLoadingMessage(false) });
    return () => { start.unsubscribe(); end.unsubscribe(); };
  }, []);

  return (
    <Modal
      isOpen={apiLoadingMessage}
      shouldCloseOnOverlayClick={false}
      shouldCloseOnEsc={false}
      contentLabel=""
      style={{
        overlay: { ...ModalOverlayStyle, backgroundColor: 'rgba(0, 0, 0, 0.2)' },
        content: ModalContentStyle,
      }}
    >
      <div style={{ display: 'flex', height: '150px', width: '350px', justifyContent: 'center', alignItems: 'center', fontSize: '18px' }}>
        <Spinner /> The application is loading
      </div>
    </Modal>
  );
};

export const GlobalLoadingWithMessageModal = () => {
  const [apiLoadingWithMessage, setApiLoadingWithMessage] = useState<string | null>(null);

  useEffect(() => {
    const start = postal.subscribe({ channel: 'ajax', topic: 'ajax.loadingwithmessagestart', callback: (data: { message: string }) => setApiLoadingWithMessage(data.message) });
    const end = postal.subscribe({ channel: 'ajax', topic: 'ajax.loadingwithmessageend', callback: () => setApiLoadingWithMessage(null) });
    return () => { start.unsubscribe(); end.unsubscribe(); };
  }, []);

  return (
    <Modal
      isOpen={apiLoadingWithMessage !== null}
      shouldCloseOnOverlayClick={false}
      shouldCloseOnEsc={false}
      contentLabel=""
      style={{
        overlay: { ...ModalOverlayStyle, backgroundColor: 'rgba(0, 0, 0, 0.2)' },
        content: ModalContentStyle,
      }}
    >
      <div style={{ display: 'flex', height: '150px', width: '430px', justifyContent: 'center', alignItems: 'center', fontSize: '18px' }}>
        <Spinner /> {apiLoadingWithMessage}
      </div>
    </Modal>
  );
};